/**
 * Copy UTM and common paid-attribution params from the current page onto the booking URL
 * so partner landing → booking form keeps campaign context.
 *
 * Covers major search/social/programmatic click IDs (matched case-insensitively).
 * Does not overwrite keys already present on the booking link.
 */

const MARKETING_EXACT = new Set([
	// Google
	'gclid',
	'gbraid',
	'wbraid',
	'dclid',
	// Meta
	'fbclid',
	// Microsoft
	'msclkid',
	// LinkedIn
	'li_fat_id',
	// X (Twitter)
	'twclid',
	// TikTok
	'ttclid',
	// Snapchat (often appears as ScCid; normalized to lowercase for lookup)
	'sccid',
	// Pinterest
	'epik',
	// Reddit
	'rdt_cid',
	// Native / programmatic
	'tblci',
	'ob_click_id',
]);

function isMarketingParamKey(key) {
	const lower = String(key).toLowerCase();
	if (lower.startsWith('utm_')) return true;
	return MARKETING_EXACT.has(lower);
}

export function bookingUrlWithMarketingParams(bookingUrl) {
	if (typeof window === 'undefined' || !bookingUrl) return bookingUrl;
	try {
		const next = new URL(bookingUrl, window.location.href);
		const incoming = new URLSearchParams(window.location.search);
		for (const [key, value] of incoming.entries()) {
			if (!isMarketingParamKey(key)) continue;
			if (!next.searchParams.has(key)) {
				next.searchParams.append(key, value);
			}
		}
		return next.toString();
	} catch {
		return bookingUrl;
	}
}
